export default __webpack_public_path__ + "static/media/receipt-long.80638870.svg";